module.exports = __webpack_public_path__ + "static/media/logo_desa.58e29947.png";